// extracted by mini-css-extract-plugin
export default {"subtitle":"CustomerAccessModal_subtitle__74SeC","modalContent":"CustomerAccessModal_modalContent__ahOGU","itemSkeleton":"CustomerAccessModal_itemSkeleton__9tH5D"};